import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { TrainingSetup } from "@/features/training/modules/training-setup/training-setup";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/training/setup")({
  loader: () => ({ crumb: m.training_setup_title() }),
  validateSearch: z.object({ new: z.boolean().optional().catch(undefined) }),
  component: SetupPage,
});

function SetupPage() {
  const search = Route.useSearch();
  return <TrainingSetup newPlan={Boolean(search.new)} />;
}
